import { ReportTypes } from "../enums/report-generator";

export const REPORT_TYPES = [
  {
    label: "Lesson report",
    value: ReportTypes.Lesson
  },
  {
    label: "Topic report",
    value: ReportTypes.Unit
  },
  {
    label: "Level report",
    value: ReportTypes.Level
  },
  {
    label: "Diagnostic report",
    value: ReportTypes.DiagnosticTestReport
  },
  {
    label: "Start Line report",
    value: ReportTypes.BaselineTestReport
  },

  {
    label: "Checkpoint report",
    value: ReportTypes.AssessmentReport
  },
  {
    label: "Progress report",
    value: ReportTypes.ProgressReport
  }
];
